import React, { useEffect, useState } from "react";

import { Line } from "react-chartjs-2";

import Chart from "chart.js/auto"; // musi ostat, lebo crashuje app, volaco registruje Chart.js

const options = {
  scales: {
    x: {
      grid: {
        display: false,
      },
    },
    y: {
      grid: {
        color: "#E3EEF6",
        borderDash: [5],
        drawTicks: false, // -pomlcka medzi cislom aj liniju
      },
      min: 0,
      max: 100,
      ticks: {
        padding: 10,
      },
    },
  },
  plugins: {
    legend: {
      display: false,
    },
  },
  elements: {
    line: {
      tension: 0.5, // disables bezier curves
    },
    point: {
      radius: 0, // disables
    },
  },
};

let gradient;
const getGradient = (ctx) => {
  gradient = ctx.createLinearGradient(0, 200, 0, 0);
  gradient.addColorStop(0, "rgba(38,72,164,0.11)");
  gradient.addColorStop(1, "rgba(38,72,164,0.3)");
  return gradient;
};

const ChartLine = ({ data }) => {
  const handle = () => {};

  const [graphLabels, setGraphLabels] = useState([]);
  const [graphData, setGraphData] = useState([
    {
      label: "",
      data: [],
      fill: true,
      backgroundColor: function (context) {
        const chart = context.chart;
        const { ctx, chartArea } = chart;
        return getGradient(ctx, chartArea);
      },
      borderColor: "rgba(38,72,164,1)",
      borderWidth: 2,
    },
  ]);

  useEffect(() => {
    setGraphLabels(data.map((item) => item.label));
    setGraphData((prevState) => {
      const retState = [...prevState];
      retState[0].data = data.map((item) => item.datasetvalue);

      return retState;
    });
  }, [data]);

  return (
    <div>
      <Line
        options={options}
        data={{ labels: graphLabels, datasets: graphData }}
      />
    </div>
  );
};

export default ChartLine;
